import React from 'react'
import {
  buildStyles,
  CircularProgressbar as ReactCircularProgressbar,
} from 'react-circular-progressbar'

export const CircularProgressbar = props => (
  <div style={{ width: 20, height: 20 }}>
    <ReactCircularProgressbar
      {...props}
      styles={buildStyles({
        pathColor: '#354052',
        trailColor: 'transparent',
        backgroundColor: 'transparent',
      })}
    />
  </div>
)
